<template>
  <div class="fuel-card bg-white rounded-lg shadow-md p-4 border-l-4 border-blue-500">
    <div class="flex justify-between items-start mb-3">
      <div>
        <h3 class="text-lg font-semibold text-gray-800">{{ equipmentName }}</h3>
        <p class="text-sm text-gray-600">{{ formatDate(transaction.transaction_date) }}</p>
      </div>
      <span class="px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full"> Fuel </span>
    </div>

    <div class="space-y-2 text-sm text-gray-600">
      <div class="flex justify-between">
        <span>Liters:</span>
        <span class="font-medium">{{ Number(transaction.liters || 0).toFixed(1) }}L</span>
      </div>

      <div class="flex justify-between">
        <span>Cost per Liter:</span>
        <span class="font-medium">tsh{{ Number(transaction.cost_per_liter || 0).toFixed(2) }}</span>
      </div>

      <div class="flex justify-between">
        <span>Total Cost:</span>
        <span class="font-medium text-green-600"
          >tsh{{
            Number(
              transaction.total_cost ||
                (transaction.liters && transaction.cost_per_liter
                  ? Number(transaction.liters) * Number(transaction.cost_per_liter)
                  : 0),
            ).toFixed(2)
          }}</span
        >
      </div>

      <div v-if="transaction.notes" class="mt-2 pt-2 border-t border-gray-200">
        <p class="text-sm text-gray-600 italic">"{{ transaction.notes }}"</p>
      </div>
    </div>

    <div class="mt-4 flex space-x-2">
      <button @click="$emit('edit', transaction)" class="btn-secondary text-xs px-3 py-1">
        Edit
      </button>
      <button @click="$emit('view', transaction)" class="btn-primary text-xs px-3 py-1">
        View
      </button>
      <button @click="$emit('delete', transaction.id)" class="btn-danger text-xs px-3 py-1">
        Delete
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { FuelTransaction } from '@/types/fuel'

interface Props {
  transaction: FuelTransaction
}

const props = defineProps<Props>()
defineEmits<{
  (e: 'edit', transaction: FuelTransaction): void
  (e: 'view', transaction: FuelTransaction): void
  (e: 'delete', id: number): void
}>()

import { computed } from 'vue'
import { useEquipmentStore } from '@/stores/equipmentStore'

const equipmentStore = useEquipmentStore()

const equipmentName = computed(() => {
  const transaction = props.transaction
  if (transaction.equipment && transaction.equipment.name) return transaction.equipment.name
  const id = Number(transaction.equipment_id)
  if (!Number.isFinite(id)) return ''

  // Use store helper which triggers background fetch when name missing
  return equipmentStore.getName(id)
})

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString()
}
</script>

<style scoped>
.fuel-card {
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.fuel-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
</style>
